const imports = require("../../../../lib");
module.exports = imports.stronachgroup.first.racehorse360;

const grpc = {};
grpc.web = require("grpc-web");

module.exports.RaceConditionServiceSimpleClient =
  function RaceConditionServiceSimpleClient(hostname, credentials, options) {
    if (!options) options = {};
    options["format"] = "text";

    this.client_ = new grpc.web.GrpcWebClientBase(options);
    this.hostname_ = hostname;
    this.credentials_ = credentials;
    this.options_ = options;

    this.pullRaceConditions = this.pullRaceConditions.bind(this);
    this.pullRaceConditionsForHorse =
      this.pullRaceConditionsForHorse.bind(this);
    this.pullRaceConditionsFacilities =
      this.pullRaceConditionsFacilities.bind(this);
  };
const methodInfo_RaceConditionService_PullRaceConditions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditions",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsRequest,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullRaceConditionsResponse.decode
  );
module.exports.RaceConditionServiceSimpleClient.prototype.pullRaceConditions =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullRaceConditionsRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditions",
      message,
      metadata || {},
      methodInfo_RaceConditionService_PullRaceConditions
    );
  };
const methodInfo_RaceConditionService_PullRaceConditionsForHorse =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsForHorse",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullRaceConditionsForHorseResponse.decode
  );
module.exports.RaceConditionServiceSimpleClient.prototype.pullRaceConditionsForHorse =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullRaceConditionsForHorseRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsForHorse",
      message,
      metadata || {},
      methodInfo_RaceConditionService_PullRaceConditionsForHorse
    );
  };
const methodInfo_RaceConditionService_PullRaceConditionsFacilities =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsFacilities",
    grpc.web.MethodType.UNARY,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest,
    imports.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse,
    function (message) {
      return message.constructor.encode(message).finish();
    },
    imports.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesResponse.decode
  );
module.exports.RaceConditionServiceSimpleClient.prototype.pullRaceConditionsFacilities =
  function (request, metadata) {
    const message =
      imports.stronachgroup.first.racehorse360.PullRaceConditionsFacilitiesRequest.create(
        request
      );
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.RaceConditionService/PullRaceConditionsFacilities",
      message,
      metadata || {},
      methodInfo_RaceConditionService_PullRaceConditionsFacilities
    );
  };
